import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CoalImageGallery({ images, onImageClick }) {
    const { t } = useTranslation();

    if(!images || images.length === 0) return null;

    return (
        <div>
            <hr className="bg-gray-600 opacity-2" />
            <div className='row'>
                <div className='col w-50'>
                    <p><b>{t('carvão.result.camposImagem')}:</b></p>
                </div>
            </div>
            {
                <div className="d-flex flex-wrap justify-content-center gap-3">
                    {images.map((image, index) => (
                        <img key={image.id ?? index} src={image.photo}
                            className="rounded h-250px w-250px"
                            style={{ objectFit: 'contain', cursor: 'pointer' }}
                            onClick={() => onImageClick(index)} />
                    ))}
                </div>
            }
        </div>
    )
}
